module.exports = __webpack_public_path__ + "static/media/background-feet.3e19b386.png";